module.exports = __webpack_public_path__ + "assets/close.44482793.svg";